import { useUser } from 'hooks/useUser';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// TODO: Is this used?
export function Spotify() {
  const { t } = useTranslation();
  const {
    user,
    spotifyToken,
    setSpotifyToken,
    redirectUri,
    setRedirectUri,
    startSpotify,
    setStartSpotify,
  } = useUser();
  const navigate = useNavigate();

  const params = getHashParams();
  const token = (params as { access_token?: string })['access_token'] || '';

  useEffect(() => {
    if (token) {
      setSpotifyToken(token);
      //navigate(`${redirectUri}/spotify`);
      setStartSpotify(true);
    } else {
      //navigate(redirectUri);
      setStartSpotify(false);
    }
    navigate(redirectUri);
  }, [token]);

  return (
    <div>
      <h1>{t('spotify', 'Spotify')}</h1>
    </div>
  );
}

const getHashParams = (): { [key: string]: string } => {
  const hashParams: { [key: string]: string } = {};
  const r = /([^&;=]+)=?([^&;]*)/g;
  const q = window.location.hash.substring(1);
  let e = r.exec(q);
  while (e) {
    hashParams[e[1]] = decodeURIComponent(e[2]);
    e = r.exec(q);
  }
  return hashParams;
};
